module.exports = __webpack_public_path__ + "static/media/works.7b68f80b.png";